<template>
  <q-select
    :use-chips="edit && $attrs.modelValue !== 0"
    option-label="descricao"
    option-value="id"
    :use-input="$attrs.modelValue === null"
    dense
    v-bind="{ ...defaultSelectProps, ...$attrs, ...$props }"
  />
</template>

<script setup>
import { computed, defineProps, getCurrentInstance } from "vue";

const props = defineProps({
  required: { type: Boolean, default: false },
  editable: { type: Boolean, default: false },
  multiple: { type: Boolean, default: false },
});
const edit = computed(
  () =>
    getCurrentInstance().parent.parent.exposed.edit.value &&
    (props.editable || getCurrentInstance().parent.parent.exposed.isNew.value)
);

const defaultSelectProps = computed(() => ({
  class: ` ${edit.value ? "" : "q-mb-md"}`,
  lazyRules: true,
  rules: edit.value ? [props.required] : [],
  readonly: !edit.value,
  outlined: edit.value,
  hideDropdownIcon: !edit.value,
  menuAnchor: "bottom left",
  menuSelf: "top left",
  emitValue: false,
  popupContentClass: "tjpa-select-input"
}));
</script>

<style>
 .q-item--active {
  display: none!important;;
}

</style>
